export const LICENSE_ASSIGNMENT = 'Bulk License Assignment'
export const INSTRUCTIONS = `Select an Excel spreadsheet (.csv, .xls or .xlsx) for assigning licenses
and [optionally] adding admins to the assigned sites.`
export const BROWSE = 'Browse'
export const ACCESS_TOKEN_TEXT = 'Create access for tokens newly created sites'
export const UPLOAD = 'Upload'
export const TOOL_DESCRIPTION = `For each row of the uploaded spreadsheet, this tool will assign a
license to the specified customer. If a site doesn't exist in SecondStep
for this customer, it will be created. If admin email addresses are
provided, they will be added as an "Admin" role to the site assigned to
the license. If the licenses/sites already exist, they will be updated
with the provided data.`
export const NS_DESCRIPTION = `(Required) NetSuite Subscription ID the
License is a part of.`
export const NS_CUSTOMER = `(Required) NetSuite Customer ID that's associated
with this license.`
export const SKU = `(Required) SKU to add to this license.`
export const ADMIN_EMAILS = `(Optional) Email addresses of admins associated
with this site. Separate emails with semicolon. (;)`
export const DISTRICT_NAME = `(Optional) If specified, this license will be
rostered from this District's Clever account.`
export const EXTERNAL_SITE = `(Optional) If specified, this license will be
rostered using the provided Clever School ID.`



// WEBPACK FOOTER //
// ./src/containers/css-admin/roster/constants.js